<div class="tool-header-info">
  <div *ngIf="id">
    <span class="tag">{{ name }}</span>
    <span class="info">
      {{ id }}
      <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
    </span>
  </div>
</div>
